import React, { useContext } from "react";
import { Input, Form } from "antd";

import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ColonyInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Colonia">
      {getFieldDecorator("colony", {
        initialValue: implementerProfile?.colony
      })(
        <Input
          disabled={isBusy}
          id="colony"
          name="colony"
          placeholder="Colonia"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
